module.exports = __webpack_public_path__ + "img/180h100_s_2_iz_3_povorotno_otkidnymi_levoy_i_pravoy_chastyami.20832c4c.svg";